import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import {
  Info as InfoIcon,
  Event as EventIcon,
  MonetizationOn as MonetizationOnIcon,
 } from '@mui/icons-material';

import { OutlinedIconButton } from 'shared/components/styled';

const ICONS = {
  INFO: 'INFO',
  SCHEDULE: 'SCHEDULE',
  MONEY: 'MONEY'
};

export const ActionList = ({ onChange }) => {
  const theme = useTheme();
  const [selected, setSelected] = React.useState(ICONS.INFO);
  const getStyle = useCallback((type) => {
    return {
      cursor: 'pointer',
      fontSize: 30,
      color: (type === selected) ? '#444' : theme.palette.grey[400],
    };
  }, [selected]);
  const selectIcon = useCallback((type, e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelected(type);
    onChange(type);
  }, [onChange]);
  return (
    <Container>
      <Tooltip title="Show Info KPIs per portfolio">
        <OutlinedIconButton
          onClick={e => selectIcon(ICONS.INFO, e)}
          withBorder={false}
          active={selected === ICONS.SCHEDULE}
        >
          <InfoIcon style={getStyle(ICONS.INFO)} active={selected === ICONS.INFO}/>
        </OutlinedIconButton>
      </Tooltip>
      <Tooltip title="Show Schedule KPIs per portfolio">
        <OutlinedIconButton
          onClick={e => selectIcon(ICONS.SCHEDULE, e)}
          withBorder={false}
          active={selected === ICONS.SCHEDULE}
        >
          <EventIcon style={getStyle(ICONS.SCHEDULE)} active={selected === ICONS.SCHEDULE}/>
        </OutlinedIconButton>
      </Tooltip>
      <Tooltip title="Show Money KPIs per portfolio">
        <OutlinedIconButton
          onClick={e => selectIcon(ICONS.MONEY, e)}
          withBorder={false}
          active={selected === ICONS.MONEY}
        >
          <MonetizationOnIcon style={getStyle(ICONS.MONEY)} active={selected === ICONS.MONEY}/>
        </OutlinedIconButton>
      </Tooltip>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display:inline-block; 
  width: auto;
  height: 30px;
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,.2);
`;
